'use es6';

import { Map as ImmutableMap } from 'immutable';
import { handleActions } from 'flux-actions';
import get from 'transmute/get';
import ResolvedAttachmentRecord from 'conversations-internal-schema/resolved-attachment/records/ResolvedAttachmentRecord';
import { succeeded, failed } from '../../constants/asyncStatuses';
import { RESOLVE_ATTACHMENTS_FAILED, RESOLVE_ATTACHMENTS_SUCCEEDED } from '../constants/resolvedAttachmentsActionTypes';
import { THREAD_HISTORY_FILES_RECEIVED } from '../../thread-histories/constants/ActionTypes';
import { ATTACHMENT_UPLOAD_COMPLETE } from '../../file-uploads/constants/fileUploadsActionTypes';
const initialState = ImmutableMap();

// this reducer is the main store for attachments inside a thread view
// fileUploads.js is the store that holds uploads in the file component
const reducer = {
  [RESOLVE_ATTACHMENTS_FAILED](state, action) {
    const {
      fileIds
    } = action.payload;
    return fileIds.reduce((s, fileId) => s.set(String(fileId), failed(null)), state);
  },
  [RESOLVE_ATTACHMENTS_SUCCEEDED](state, action) {
    const {
      fileIds,
      resolvedAttachments
    } = action.payload;
    return fileIds.reduce((s, fileId) => s.set(String(fileId), succeeded(get(fileId, resolvedAttachments))), state);
  },
  [ATTACHMENT_UPLOAD_COMPLETE](state, action) {
    const {
      fileId,
      uploadedFile
    } = action.payload;
    const attachmentRecord = new ResolvedAttachmentRecord({
      fileMetadata: uploadedFile,
      fileId
    });
    return state.set(String(fileId), succeeded(attachmentRecord));
  },
  [THREAD_HISTORY_FILES_RECEIVED](state, action) {
    const {
      files: resolvedAttachments
    } = action.payload;
    return resolvedAttachments.reduce((s, attachment, fileId) => s.set(String(fileId), succeeded(attachment)), state);
  }
};
export default handleActions(reducer, initialState);